webpackJsonp([144251824217401],{

/***/ 375:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Edit About component or pages/about.jsx to include your information."
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _About = __webpack_require__(265);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_Component) {
	  _inherits(AboutPage, _Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "About | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_About2.default, null)
	    );
	  };
	
	  return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-16dca089dee574aef9ce.js